import React from 'react';
import FolderManagementModal from '../folder-management-modal/FolderManagementModal';
import {
  useGetLookbooksQuery,
  useCreateLookbookMutation,
  useAddResultsToLookbookMutation,
  useRemoveResultsFromLookbookMutation,
  useUpdateLookbookMutation
} from '../../redux/apis/endpoints/lookbookApi';

/**
 * Wrapper component for managing VTO results in lookbooks.
 * Uses the shared FolderManagementModal component.
 */
const ManageLookbooksModal = ({ open, onClose, selectedResultIds = [], onSuccess }) => {
  const { data: lookbooks = [], isLoading } = useGetLookbooksQuery(undefined, { skip: !open });
  const [createLookbook] = useCreateLookbookMutation();
  const [updateLookbook] = useUpdateLookbookMutation();
  const [addResultsToLookbook] = useAddResultsToLookbookMutation();
  const [removeResultsFromLookbook] = useRemoveResultsFromLookbookMutation();

  // Transform lookbooks to folder format for FolderManagementModal
  const folders = lookbooks.map(lookbook => ({
    id: lookbook.id,
    name: lookbook.name,
    isDefault: lookbook.isDefault,
    itemCount: lookbook.resultCount || lookbook.itemCount || 0,
    previewImage: lookbook.previewImage || lookbook.previewImages?.[0] || null,
    // For VTO results, they are stored in entries now (via backend transformation)
    itemIds: (lookbook.entries || []).map(item => item.id)
  }));

  // Callback handlers
  const handleCreateFolder = async (name) => {
    return createLookbook(name).unwrap();
  };

  const handleUpdateFolder = async (id, name) => {
    return updateLookbook({ id, name }).unwrap();
  };

  const handleAddItems = async (folderId, itemIds) => {
    return addResultsToLookbook({ lookbookId: folderId, resultIds: itemIds }).unwrap();
  };

  const handleRemoveItems = async (folderId, itemIds) => {
    return removeResultsFromLookbook({ lookbookId: folderId, resultIds: itemIds }).unwrap();
  };

  return (
    <FolderManagementModal
      open={open}
      onClose={onClose}
      folders={folders}
      selectedItemIds={selectedResultIds}
      isLoading={isLoading}
      onCreateFolder={handleCreateFolder}
      onUpdateFolder={handleUpdateFolder}
      onAddItems={handleAddItems}
      onRemoveItems={handleRemoveItems}
      onSuccess={onSuccess}
      title="Manage Lookbooks"
      folderIcon="book"
      itemLabel="lookbook"
      createPlaceholder="New lookbook name..."
    />
  );
};

export default ManageLookbooksModal;
